import useSWR from "swr";
import { Section } from "@/components/section";
import { useAuthStore, swrKey } from "@/lib/swr";
import { refreshRolloutTasks, rolloutTaskLabel } from "@/lib/rollout-task";
import TaskDueInput from "@/components/task-confirm/due-input";
import { TaskRowStatus } from "@/components/task-confirm/row-status";
import { taskDue } from "@/components/task-confirm/due";
import { RolloutConfirmButton } from "./rollout-confirm-button";
import type { RolloutTask, Version } from "@/types/domain";

// Version-detail aside: rollout data tasks (收入数据 / 版本数据) per channel
// rollout step (or per version for apps without channels) — shows who has
// (not) submitted so the version owner can chase. Hidden while none exist.
const RolloutTasksSection = ({ version }: { version: Version }) => {
  const user = useAuthStore((s) => s.auth?.user);
  const { data: tasks } = useSWR<RolloutTask[]>(
    swrKey("/rollout-tasks", { versionId: version.id })
  );

  if (!tasks?.length) return null;

  return (
    <Section title="Rollout data">
      <div className="flex flex-col gap-1.5">
        {tasks.map((task) => {
          const due = taskDue(task);
          const mine = !!user && task.assigneeUserId === user.id;
          return (
            <div key={task.id} className="flex items-center gap-1.5 text-sm">
              <span className="min-w-0 flex-1 truncate">
                {rolloutTaskLabel(task)}
                <span className="text-muted-foreground">
                  {" · "}
                  {task.assignee?.name ?? "unassigned"}
                </span>
              </span>
              <TaskRowStatus
                confirmedAt={task.confirmedAt}
                canAct={mine || !!user?.isAdmin}
                due={due}
              >
                <TaskDueInput
                  endpoint={`/rollout-tasks/${task.id}`}
                  onSaved={refreshRolloutTasks}
                  dueAt={task.dueAt}
                  overdue={due.overdue}
                />
                <RolloutConfirmButton
                  task={task}
                  version={version}
                  autoOpenParam
                  className="h-6 gap-1 px-1.5"
                />
              </TaskRowStatus>
            </div>
          );
        })}
      </div>
    </Section>
  );
};

export default RolloutTasksSection;
